import PropTypes from 'prop-types';
import React from 'react';

import { TagCloudSmall } from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const CarouselItemArticleDetailPageAlternative = ({
    authors = null,
    carouselItemIndex = null,
    listingImage = null,
    listingText = null,
    parentPage = null,
    publicationDate = null,
    tags = null,
    title = null,
    url = null
}) => {
    return (
        <>
            {carouselItemIndex === 0 && (
                <div className='hidden md:block md:w-1/5 layout-grid-col-padding'/>
            )}

            <div className={`group -ml-15 expand-interaction focus-within:bg-white hover:bg-white p-30${carouselItemIndex === 0 ? ' w-12/12 md:w-4/5' : ' w-12/12'}`}>
                <div className='pr-35'>
                    <a
                        className='flex flex-col'
                        href={url}>
                        {(parentPage) && (
                            <p className='type-style-4'>
                                {parentPage.title}
                            </p>
                        )}

                        <div className='flow-root mt-25'>
                            {/* image */}
                            {listingImage && (
                                <img
                                    alt={listingImage.alt}
                                    className='w-160 float-left object-cover aspect-square mr-10 pointer-events-none'
                                    height={listingImage.height}
                                    loading='lazy'
                                    src={listingImage.px2}
                                    width={listingImage.width} />
                            )}

                            {(listingText || title) && (
                                <p className='type-style-3 mt-[132px]'>
                                    {listingText || title}
                                </p>
                            )}
                        </div>

                        {(authors?.edges?.length > 0) && (
                            <p className='type-style-4 mt-20'>
                                <span>Written by </span>

                                <span dangerouslySetInnerHTML={{ __html: authors.edges.map(
                                    ({ node: person }) => {
                                        return `<span>${person.title}</span>`;
                                    }
                                ).join('<span>, </span>') }}/>
                            </p>
                        )}

                        {publicationDate && (
                            <p className='type-style-4 mt-15'>
                                {new Intl.DateTimeFormat(
                                    'en-GB',
                                    {
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric'

                                    }).format(new Date(publicationDate))}
                            </p>
                        )}
                    </a>

                    {tags.length > 0 && (
                        <div className='mt-35 pr-25 md:pr-50'>
                            <TagCloudSmall
                                tags={tags}
                                theme='bg-white' />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    authors: PropTypes.object.isRequired,
    carouselItemIndex: PropTypes.number.isRequired,
    listingImage: PropTypes.object,
    listingText: PropTypes.string.isRequired,
    parentPage: PropTypes.object.isRequired,
    publicationDate: PropTypes.string.isRequired,
    tags: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

CarouselItemArticleDetailPageAlternative.propTypes = propTypes;

export default CarouselItemArticleDetailPageAlternative;
